import LegacyApiService from "./LegacyApiService";

class TeamsService {
  getAll() {
    return LegacyApiService.get("/teams");
  }
}

export default new TeamsService();
